import { Button } from '@hausgold/designsystem';
import { map } from 'lodash-es';
import { useContext, Fragment } from 'react';
import { ApiContext, WizardContext } from '../utils/contexts.js';
import analyticsTrack from '../utils/tracking.js';
import FluidMaxContainer from '../components/FluidMaxContainer.js';
import WizardCard from '../components/WizardCard.js';
import { getLineKeys, getHeadingText, getStepKeys, getLineTitle, getLineIcon, getLineIconSVG } from '../services/models/dialog.js';
import { jsx } from '@emotion/react';
var Start = function Start() {
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    dialogId = _useContext2.dialogId,
    leadId = _useContext2.leadId,
    recruiterId = _useContext2.recruiterId;
  var _useContext3 = useContext(WizardContext),
    position = _useContext3.position,
    setCurrentLine = _useContext3.setCurrentLine,
    setCurrentStep = _useContext3.setCurrentStep,
    _useContext3$componen = _useContext3.components,
    WizardHeading = _useContext3$componen.WizardHeading,
    StartLayoutContainer = _useContext3$componen.StartLayoutContainer,
    CustomNavigationButtonsStart = _useContext3$componen.CustomNavigationButtonsStart,
    ChoiceOptionColContainer = _useContext3$componen.ChoiceOptionColContainer,
    ChoiceOptionRowContainer = _useContext3$componen.ChoiceOptionRowContainer,
    CustomWizardCard = _useContext3$componen.CustomWizardCard;
  var lines = getLineKeys(data);
  return jsx(Fragment, null, jsx(WizardHeading, null, getHeadingText(data)), jsx(FluidMaxContainer, null, jsx(StartLayoutContainer, null, jsx(ChoiceOptionRowContainer, null, map(lines, function (key) {
    return jsx(ChoiceOptionColContainer, {
      key: key,
      position: position,
      context: "start"
    }, jsx(Button, {
      as: "a",
      variant: "unstyled",
      role: "link",
      onClick: function onClick() {
        var firstStep = getStepKeys(data, key)[0];
        var chosenLine = key;
        analyticsTrack({
          event: 'Formwizard Started',
          params: {
            dialog_id: dialogId,
            lead_id: leadId,
            recruiter_id: recruiterId
          }
        });
        analyticsTrack({
          event: 'Formwizard Interacted',
          params: {
            dialog_id: dialogId,
            lead_id: leadId,
            recruiter_id: recruiterId,
            label: getLineTitle(data, key),
            step: "".concat(chosenLine, "-clickto_step", 1, "_").concat(firstStep)
          }
        });

        // Set chosen line
        setCurrentLine(chosenLine);

        // Set current step
        setCurrentStep(firstStep);
      }
    }, CustomWizardCard ? jsx(CustomWizardCard, {
      iconId: getLineIcon(data, key),
      iconSvg: getLineIconSVG(data, key),
      title: getLineTitle(data, key)
    }) : jsx(WizardCard, {
      iconId: getLineIcon(data, key),
      iconSvg: getLineIconSVG(data, key),
      title: getLineTitle(data, key)
    })));
  })), CustomNavigationButtonsStart && jsx(CustomNavigationButtonsStart, null))));
};
export { Start as default };